import { usePdfPages } from '@/hooks/usePdfPages';

const PDF_URL =
  'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/8a20eb26-d932-44d2-ac03-e10cebdede1a_konzept.pdf';

const PAGE_TRANSFORMS = [
  'md:-rotate-[5deg]',
  'md:rotate-[4deg]',
  'md:-rotate-[3deg]',
  'md:rotate-[5deg]',
];

const PAGE_OFFSETS = [
  '',
  'md:-ml-[6%] md:mt-12',
  'md:-ml-[6%] md:mt-4',
  'md:-ml-[6%] md:mt-14',
];

function PageSkeleton() {
  return (
    <div className="flex w-full flex-col items-center gap-6 md:flex-row md:items-start md:justify-center md:gap-0">
      <div className="aspect-[1/1.414] w-full max-w-xs animate-pulse rounded-md border border-background-300 bg-background-100 md:w-[34%] md:max-w-none"></div>
      <div className="aspect-[1/1.414] w-full max-w-xs animate-pulse rounded-md border border-background-300 bg-background-100 md:-ml-[6%] md:mt-12 md:w-[34%] md:max-w-none"></div>
    </div>
  );
}

export default function ConceptPages() {
  const { pages, loading, error } = usePdfPages(PDF_URL);

  return (
    <section id="material" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-primary-700">
            Kursmaterial
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
            Einblick in das Kursmaterial
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            Hier sehen Sie ausgewählte Originalseiten aus dem Kurskonzept und
            erhalten einen ersten Eindruck von der Gestaltung.
          </p>
        </div>

        <div className="relative mt-10 overflow-hidden rounded-lg border border-background-200 bg-background-50 px-6 py-10 md:mt-12 md:px-14 md:py-14">
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-100/70 via-background-50 to-accent-100/60"></div>
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>

          <div className="relative flex flex-col items-center gap-6 md:flex-row md:items-start md:justify-center md:gap-0">
            {loading && <PageSkeleton />}

            {!loading &&
              !error &&
              pages.map((src, index) => (
                <figure
                  key={src}
                  className={`w-full max-w-xs shrink-0 overflow-hidden rounded-md border border-background-300 bg-background-50 shadow-[0_20px_40px_-26px_rgba(0,0,0,0.35)] transition-transform duration-500 hover:-translate-y-2 md:w-[34%] md:max-w-none ${
                    PAGE_TRANSFORMS[index % PAGE_TRANSFORMS.length]
                  } ${PAGE_OFFSETS[index % PAGE_OFFSETS.length]}`}
                  style={{ zIndex: index + 1 }}
                >
                  <img
                    src={src}
                    alt={`Originalseite ${index + 1} aus dem Kurskonzept`}
                    className="block h-auto w-full"
                  />
                </figure>
              ))}
          </div>

          {error && (
            <div className="relative flex flex-col items-center gap-3 text-center">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                <i className="ri-error-warning-line text-lg"></i>
              </span>
              <p className="text-sm text-foreground-600">
                Die Vorschau konnte gerade nicht geladen werden.
              </p>
              <a
                href={PDF_URL}
                target="_blank"
                rel="nofollow noopener"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                Originalseiten öffnen
              </a>
            </div>
          )}
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-lg border border-primary-100 bg-primary-50 px-5 py-4 md:mt-10 sm:flex-row sm:items-center md:px-6">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-calendar-check-line text-lg"></i>
            </span>
            <div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 md:text-lg">
                Sie möchten das komplette Konzept sehen?
              </h3>
              <p className="mt-0.5 text-sm leading-relaxed text-foreground-600">
                Vereinbaren Sie gerne einen Termin für ein kostenloses Erstgespräch.
              </p>
            </div>
          </div>
          <a
            href="#kontakt"
            className="shrink-0 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            Termin vereinbaren
          </a>
        </div>
      </div>
    </section>
  );
}